export default "__VITE_ASSET__ByoQyObD__"